import type { Messages } from "./en";
export const de: Messages = {
  "meta.title": "ArtLove365 - Handgemalte Ölgemälde",
  "meta.description": "Handgemalte Öl-Reproduktionen der größten Meisterwerke der Welt und individuelle Ölporträts nach Ihren Fotos.",
  "nav.gallery": "Galerie",
  "nav.artists": "Künstler",
  "nav.custom": "Mein Foto malen",
  "nav.track": "Bestellung verfolgen",
  "home.eyebrow": "Von echten Künstlern in Öl von Hand gemalt",
  "home.title": "Meisterwerke für Ihre Wände. Ihre Erinnerungen, gemalt wie Meisterwerke.",
  "home.subtitle": "Wählen Sie aus den beliebtesten Gemälden der Geschichte oder laden Sie Ihr eigenes Foto hoch. Unsere Künstler malen es von Hand auf Leinwand und liefern es zu Ihnen nach Hause.",
  "home.ctaGallery": "Galerie ansehen",
  "home.ctaCustom": "Foto hochladen",
  "home.stepsTitle": "So funktioniert es",
  "home.step1Title": "Auswählen oder hochladen",
  "home.step1Body": "Wählen Sie ein Meisterwerk oder laden Sie ein Foto Ihrer Familie, Ihres Haustiers oder Lieblingsorts hoch.",
  "home.step2Title": "Wir malen es",
  "home.step2Body": "Ein professioneller Ölmaler arbeitet auf echter Leinwand. Bei individuellen Aufträgen geben Sie zuerst eine Skizze frei.",
  "home.step3Title": "Zu Ihnen geliefert",
  "home.step3Body": "Nach dem Trocknen wird Ihr Gemälde sorgfältig verpackt und weltweit mit Sendungsverfolgung verschickt.",
  "home.featured": "Ausgewählte Meisterwerke",
  "gallery.title": "Galerie der Meisterwerke",
  "gallery.subtitle": "Jedes Gemälde wird von Hand in Öl auf Leinwand reproduziert - niemals gedruckt.",
  "gallery.filterAll": "Alle Künstler",
  "gallery.empty": "Keine Gemälde gefunden.",
  "artists.title": "Die Meister",
  "artists.works": "Werke ansehen",
  "artwork.by": "von",
  "artwork.order": "Dieses Gemälde bestellen",
  "artwork.notFound": "Dieses Gemälde wurde nicht gefunden.",
  "order.size": "Leinwandgröße",
  "order.frame": "Ausführung",
  "frame.rolled": "Gerollte Leinwand (in einer Röhre)",
  "frame.stretched": "Auf Keilrahmen, fertig zum Aufhängen",
  "frame.framed": "Keilrahmen + Holzrahmen",
  "order.subjects": "Personen oder Tiere auf dem Foto",
  "order.price.base": "Gemälde",
  "order.price.frame": "Ausführung",
  "order.price.custom": "Individuelles Porträt",
  "order.price.shipping": "Versand",
  "order.price.free": "Kostenlos",
  "order.price.total": "Gesamt",
  "order.contact": "Lieferadresse",
  "order.name": "Vollständiger Name",
  "order.email": "E-Mail",
  "order.phone": "Telefon",
  "order.address": "Straße und Hausnummer",
  "order.city": "Stadt",
  "order.postalCode": "Postleitzahl",
  "order.country": "Land",
  "order.notes": "Hinweise für den Künstler (optional)",
  "order.submit": "Weiter zur Zahlung",
  "order.submitting": "Bestellung wird aufgegeben…",
  "order.error": "Etwas ist schiefgelaufen. Bitte prüfen Sie das Formular und versuchen Sie es erneut.",
  "order.leadTime": "Das Malen dauert 2-3 Wochen, dazu 1 Woche Trocknung vor dem Versand.",
  "custom.title": "Verwandeln Sie Ihr Foto in ein Ölgemälde",
  "custom.subtitle": "Laden Sie ein scharfes, gut beleuchtetes Foto hoch. Unsere Künstler malen es von Hand - und Sie geben die Skizze frei, bevor wir beginnen.",
  "custom.upload": "Foto auswählen",
  "custom.uploadHint": "JPG, PNG oder WebP, bis 20 MB. Höhere Auflösung ergibt ein besseres Gemälde.",
  "custom.uploading": "Wird hochgeladen…",
  "custom.uploaded": "Foto hochgeladen",
  "custom.replace": "Anderes Foto verwenden",
  "custom.style": "Malstil",
  "custom.style.classic": "Klassischer Realismus",
  "custom.style.impressionist": "Impressionistisch (wie Monet)",
  "custom.style.vangogh": "Ausdrucksstarker Pinselstrich (wie Van Gogh)",
  "custom.style.modern": "Modern, sanfte Farben",
  "custom.needPhoto": "Bitte laden Sie zuerst ein Foto hoch.",
  "track.title": "Bestellung verfolgen",
  "track.code": "Bestellnummer",
  "track.submit": "Bestellung suchen",
  "track.notFound": "Wir haben keine Bestellung mit dieser Nummer und E-Mail gefunden.",
  "track.placed": "Bestellt am",
  "success.title": "Vielen Dank! Ihre Bestellung ist eingegangen.",
  "success.body": "Wir haben Ihnen eine Bestätigung per E-Mail gesendet. Bewahren Sie Ihre Bestellnummer auf, um den Fortschritt zu verfolgen.",
  "status.awaiting_payment": "Zahlung ausstehend",
  "status.paid": "Bezahlt",
  "status.sketching": "Skizze",
  "status.painting": "Wird gemalt",
  "status.drying": "Trocknet",
  "status.shipped": "Versandt",
  "status.delivered": "Zugestellt",
  "status.cancelled": "Storniert",
  "common.loading": "Wird geladen…",
  "common.back": "Zurück",
  "footer.tagline": "Handgemalte Ölgemälde, weltweiter Versand.",
  "footer.follow": "Folge uns",
  "footer.docs": "Hilfe und Dokumentation",
  "gallery.search": "Gemälde oder Künstler suchen…",
  "sketch.title": "Ihre Skizze ist fertig",
  "sketch.body": "Bitte prüfen Sie die Komposition. Wir beginnen erst nach Ihrer Freigabe zu malen.",
  "sketch.approve": "Skizze freigeben",
  "sketch.change": "Änderungen anfordern",
  "sketch.feedback": "Was sollen wir ändern?",
  "sketch.send": "Feedback senden",
  "sketch.approved": "Skizze freigegeben - wir malen bereits.",
  "sketch.changesSent": "Danke! Der Künstler schickt Ihnen eine überarbeitete Skizze.",
  "checkout.title": "Zahlung",
  "checkout.demoBanner": "Demo-Modus - die Online-Zahlung ist noch nicht aktiv. Es wird nichts abgebucht und keine Kartendaten werden erfasst.",
  "checkout.summary": "Bestellübersicht",
  "checkout.method": "Zahlungsart",
  "checkout.method.card": "Kredit- / Debitkarte",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Banküberweisung",
  "checkout.cardNumber": "Kartennummer",
  "checkout.expiry": "Gültig bis (MM/JJ)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Name auf der Karte",
  "checkout.paypalNote": "Sie werden zu PayPal weitergeleitet, um die Zahlung zu bestätigen.",
  "checkout.walletNote": "Bestätigen Sie mit Face ID, Touch ID oder Ihrem Telefon.",
  "checkout.bankNote": "Wir senden Ihnen unsere Bankverbindung per E-Mail. Ihre Bestellung startet nach Zahlungseingang (1-3 Werktage).",
  "checkout.pay": "{amount} bezahlen",
  "checkout.processing": "Zahlung wird verarbeitet…",
  "checkout.secure": "Zahlungen sind verschlüsselt und werden von unserem Zahlungspartner abgewickelt. Wir speichern niemals Kartennummern.",
  "checkout.demoDoneTitle": "Zahlung simuliert",
  "checkout.demoDoneBody": "Dies war eine Demo - es wurde nichts abgebucht. Ihre Bestellung ist gespeichert und bleibt „Zahlung ausstehend“; unser Team meldet sich, um die Zahlung abzuschließen.",
  "checkout.failTitle": "Zahlung abgelehnt",
  "checkout.failBody": "Ihre Bank hat die Zahlung abgelehnt. Bitte prüfen Sie die Angaben oder wählen Sie eine andere Zahlungsart.",
  "checkout.retry": "Erneut versuchen",
  "checkout.viewOrder": "Meine Bestellung ansehen",
  "track.payNow": "Jetzt bezahlen",
  "browse.title": "Entdecken",
  "browse.movements": "Kunstrichtungen",
  "browse.museums": "Museen",
  "browse.subjects": "Motive",
  "browse.genres": "Gattungen",
  "artwork.year": "Jahr",
  "artwork.size": "Originalgröße",
  "artwork.museum": "Museum",
  "artwork.movement": "Stilrichtung",
  "artwork.genre": "Gattung",
  "artwork.subjects": "Motive",
  "artwork.moreBy": "Mehr von",
  "pager.prev": "Zurück",
  "pager.next": "Weiter",
  "count.paintings": "{n} Gemälde",
  "fav.add": "Zu Favoriten hinzufügen",
  "fav.remove": "Aus Favoriten entfernen",
  "fav.title": "Meine Favoriten",
  "fav.empty": "Noch keine Favoriten. Tippen Sie bei jedem Gemälde, das Ihnen gefällt, auf das Herz - es wartet hier auf Sie.",
  "fav.emptyCta": "Galerie entdecken",
  "fav.syncHint": "Melden Sie sich mit Google an, um Ihre Favoriten auf allen Geräten zu behalten.",
  "fav.saved": "In Ihren Favoriten gespeichert",
  "fav.nav": "Favoriten",
  "account.signIn": "Anmelden",
  "account.signOut": "Abmelden",
  "account.signedInAs": "Angemeldet als",
  "account.signInTitle": "Bei ArtLove365 anmelden",
  "viewer.open": "Vollbild ansehen",
  "viewer.close": "Schließen",
  "viewer.hint": "Scrollen oder zoomen mit zwei Fingern · ziehen zum Erkunden · Doppelklick zum Zurücksetzen",
  "share.button": "Teilen",
  "share.copied": "Link kopiert",
  "artwork.story": "Über dieses Gemälde",
  "artwork.details": "Details",
  "artwork.aboutArtist": "Über den Künstler",
  "artwork.readArtist": "Die Lebensgeschichte von {name} entdecken",
  "artwork.relatedArtists": "Werke verwandter Künstler",
  "rel.influenced_by": "Inspirierte {artist}",
  "rel.influenced": "Inspiriert von {artist}",
  "rel.student_of": "Lehrer von {artist}",
  "rel.student": "Schüler von {artist}",
  "rel.movement": "Ebenfalls {movement}",
  "story.didYouKnow": "Schon gewusst?",
  "story.sources": "Quellen",
  "story.aiNote": "Mit Hilfe von KI aus den unten genannten Quellen verfasst. Einen Fehler entdeckt? Sagen Sie es uns.",
  "artist.relatedArtists": "Verwandte Künstler",
  "artist.worksBy": "Gemälde von {name}",
  "nav.how": "So arbeiten wir",
  "home.ctaArtists": "Die Künstler entdecken",
  "home.discover": "Lernen Sie uns kennen",
  "home.howCardTitle": "So arbeiten wir",
  "home.howCardBody": "Echte Maler, echte Leinwand, Ölfarbe und Geduld. Sehen Sie, wie ein Meisterwerk von Hand neu entsteht.",
  "home.customCardTitle": "Ihr Foto, in Öl gemalt",
  "home.customCardBody": "Familie, Paare, Haustiere, das Haus Ihrer Kindheit - so wird aus einem Foto ein Gemälde.",
  "home.featuredArtists": "Die großen Meister",
  "home.browseMovements": "Nach Stilrichtung entdecken",
  "common.readMore": "Weiterlesen",
  "how.title": "So arbeiten wir",
  "how.intro": "Jedes Gemälde von ArtLove365 wird von professionellen Malern von Hand in Öl auf echter Leinwand gemalt. Kein Druck, keine Abkürzungen. Das geschieht zwischen einem Meisterwerk und Ihrer Wand.",
  "how.s1t": "Es beginnt mit einem Gemälde, das Sie berührt",
  "how.s1b": "Entdecken Sie Tausende Meisterwerke, lesen Sie ihre Geschichten und speichern Sie Ihre Lieblinge in den Favoriten.",
  "how.s2t": "Ein Maler studiert das Original",
  "how.s2b": "Vor dem ersten Strich studiert der Maler Komposition, Farbe und die Art, wie der Meister die Farbe auftrug - die Reihenfolge der Schichten zählt so viel wie die Farben.",
  "how.s3t": "Von Hand gemalt, Schicht für Schicht",
  "how.s3b": "Öl wird langsam aufgebaut: Untermalung, die großen Flächen, dann Details und Lasuren. Eine mittelgroße Leinwand braucht zwei bis drei Wochen Arbeit.",
  "how.s4t": "Geprüft, dann getrocknet",
  "how.s4b": "Ein erfahrener Maler vergleicht die Leinwand mit dem Original. Danach braucht die Ölfarbe etwa eine Woche, bis sie sicher reisen kann.",
  "how.s5t": "Sorgfältig verpackt, weltweit versandt",
  "how.s5b": "Gemälde reisen gerollt in einer stabilen Röhre oder aufgespannt in einer verstärkten Kiste - mit Sendungsverfolgung bis zu Ihrer Tür.",
  "how.materialsTitle": "Materialien",
  "how.materialsBody": "Ölfarben in Künstlerqualität, grundierte Baumwoll- oder Leinenleinwand und ein Firnis, der die Oberfläche jahrzehntelang schützt.",
  "how.customTitle": "Gemalt nach Ihrem eigenen Foto",
  "how.customBody": "Bei Porträts und persönlichen Motiven gibt es einen zusätzlichen Schritt: Sie geben eine Skizze der Komposition frei, bevor wir zu malen beginnen.",
  "custom.pageTitle": "Individuelle Ölgemälde nach Ihren Fotos",
  "custom.pageIntro": "Ein Foto hält einen Moment fest. Ein Gemälde lässt ihn bleiben. Unsere Maler verwandeln Ihre Fotos in handgemalte Ölporträts und Szenen - im Stil Ihrer Wahl.",
  "custom.howTitle": "So funktioniert es",
  "custom.step1t": "Sie teilen ein Foto",
  "custom.step1b": "Ein scharfes Foto genügt; wir können auch mehrere zu einer Szene vereinen.",
  "custom.step2t": "Sie geben eine Skizze frei",
  "custom.step2b": "Unser Maler bereitet die Komposition vor. Gemalt wird erst, wenn Sie zufrieden sind.",
  "custom.step3t": "Wir malen von Hand",
  "custom.step3b": "Öl auf Leinwand, Schicht für Schicht, im gewählten Stil.",
  "custom.step4t": "Es kommt nach Hause",
  "custom.step4b": "Nach dem Trocknen und einer letzten Prüfung wird Ihr Gemälde verpackt und mit Sendungsverfolgung verschickt.",
  "custom.stylesTitle": "Wählen Sie einen Stil",
  "custom.styleDesc.classic": "Getreue Ähnlichkeit, weiches Licht und feine Details in der Tradition der Alten Meister.",
  "custom.styleDesc.impressionist": "Licht und Stimmung in lockeren, lebendigen Tupfen - wie ein Sommernachmittag bei Monet.",
  "custom.styleDesc.vangogh": "Dicker, wirbelnder Pinselstrich und kräftige Farben, inspiriert von Van Gogh.",
  "custom.styleDesc.modern": "Klare Formen und eine sanfte, zeitgemäße Palette für moderne Räume.",
  "custom.occasionsTitle": "Beliebt für",
  "custom.occ.family": "Familienporträts",
  "custom.occ.couples": "Paare und Hochzeiten",
  "custom.occ.pets": "Haustiere",
  "custom.occ.children": "Kinder",
  "custom.occ.memorial": "In liebevoller Erinnerung",
  "custom.occ.home": "Häuser und Orte",
  "custom.tipsTitle": "Ein gutes Foto wählen",
  "custom.tip1": "Scharf, besonders die Augen.",
  "custom.tip2": "Weiches Tageslicht; harten Blitz und starke Filter vermeiden.",
  "custom.tip3": "Gesichter groß genug, um den Ausdruck gut zu erkennen.",
  "custom.tip4": "Mehrere Fotos? Wir können Personen oder Tiere in einem Gemälde vereinen.",
  "custom.explore": "Stile in der Galerie entdecken",
  "showcase.title": "Aufträge, die wir gemalt haben",
  "showcase.subtitle": "Echte Gemälde für unsere Kunden, mit deren Erlaubnis gezeigt.",
  "showcase.all": "Alle",
  "custom.occ.nail": "Deko für Nagelstudios",
  "custom.occ.other": "Sonstiges",
  "home.newTitle": "Neu erzählte Geschichten",
  "home.newWhy": "Die neuesten Gemälde mit ihrer ganzen Geschichte - jeden Tag etwas Neues.",
  "home.gemsTitle": "Verborgene Schätze",
  "home.gemsWhy": "Weniger berühmt, genauso berührend. Gemälde, an denen fast alle vorbeigehen - zu Unrecht.",
  "taxon.faqTitle": "Neugierig auf {name}?",
  "notFound.title": "Seite nicht gefunden",
};
